<template lang="pug">
  div
    h1.title.is-3.has-text-info(style='margin-bottom: 5px;') Grupos
    .buttons(style='margin-bottom: 10px;' )
      button.button.is-info.is-light(@click="reloadData")
        span.icon.is-small(:class="{ 'is-loading': storing }")
          i.fas.fa-redo-alt
      button.button.is-primary.is-light(@click="addData")
        span.icon.is-small
          i.fas.fa-plus
    .columns.is-vcentered.is-multiline(v-if="grupos.length")
      .column.is-full-mobile.is-half-tablet.is-one-third-desktop.is-one-quarter-widescreen(v-for="cong in grupos" :key="cong.id")
        .card
          .card-content
            .content
              p.title.is-5.has-text-centered {{ cong.name }}
              p.is-size-6(style="font-style: italic; margin-top: 20px; margin-bottom: 35px; text-align: center;" v-if="cong.notes") {{ cong.notes }}
              p.is-size-7 
                strong Usuarios:  
                span {{ cong.usuarios || 0 }} registrados.
          .card-footer
            a.card-footer-item.no_select.has-text-link(@click="setDetalles(cong)") Asignar
            a.card-footer-item.no_select.has-text-link(@click="setedition(cong)") Editar
            a.card-footer-item.no_select.has-text-danger(@click="setDelete(cong.id)") Eliminar
    .title.is-4(v-else) No hay registros.
    Modal(v-model="confirmModal")
      .modal-card
        article.message.is-danger
          .message-header
            p.is-3 Advertencia
          .message-body.has-text-centered ¿ Está seguro de eliminar el registro ?
          .buttons(style="margin-bottom: 10px; display: inline-block; position: relative; left: 50%; transform: translateX(-50%);")
            button.button.is-danger(@click="continueDelete(confirmModal)")
              span Confirmar
            button.button.is-info(@click="confirmModal = false")
              span Cancelar
    Modal(v-model="openModal")
      .modal-card
        header.modal-card-head
          p.modal-card-title {{ selectedId ? "Edición" : "Creación"}} de Grupo
        section.modal-card-body
          .field
            label.label(for="congName") Nombre de Grupo
            .control
              input.input(id="congName" type="text" placeholder="Ingresa el nombre" v-model="objetivo.name")
          .field
            label.label(for="congDescr") Notas
            .control
              textarea.textarea(id="congDescr" placeholder="Algo característico" v-model="objetivo.notes")

        footer.modal-card-foot
          button.button.is-success(@click="saveData" :class="{ 'is-loading': storing }") Guardar
    Modal(v-model="openUsersModal")
      .modal-card
        header.modal-card-head
          p.modal-card-title Usuarios para asignar
        section.modal-card-body
          .columns
            .column
              .control.has-icons-left(:class="{'has-icons-right': search !== ''}")
                input.input.is-small.is-rounded(type="text" placeholder="Busqueda" v-model="search")
                span.icon.is-small.is-left.has-text-info
                  i.fas.fa-search
                span.icon.is-small.is-right.has-text-danger(
                  v-if="search !== ''"
                  @click="search = ''"
                  style="cursor: pointer; pointer-events: initial;")
                  i.fas.fa-times
          table.table.is-striped
            thead
              tr
                th Correo
                th Estado
            tbody
              tr(v-for="user in usuariosSearchAndSelect" :key="user.id")
                td {{ user.email }}
                td
                  .field
                    label.checkbox(@input="setElementUsuario(user.id, 'selected', !user.selected)")
                      input(type="checkbox" :checked="user.selected" )
                      span(style="margin-left: 5px;") {{ user.selected ? "Incluido" : "No seleccionado"}}

        footer.modal-card-foot
          button.button.is-success(@click="saveDataUsuarios" :class="{ 'is-loading': storing }") Guardar
</template>

<script>
import Modal from "@/components/Modal";
import { mapState, mapActions } from "vuex";

export default {
  name: "grupo-component",

  components: {
    Modal
  },

  data: () => ({
    openModal: false,
    openUsersModal: false,
    search: "",
    confirmModal: false,
    selectedId: null,
    objetivo: {
      name: "",
      notes: "",
      usuarios: 0
    },
    usuariosSelect: [],
    usuariosSearchAndSelect: [],
    actionDrop: false,
    timersearch: null
  }),

  created() {
    this.reloadData();
  },

  watch: {
    search() {
      this.searcher();
    },
    usuariosSelect() {
      this.compareLists();
    },
    colegios_sel(val) {
      if (val) this.reloadData();
    },
    actualUsuariosSelect(val) {
      this.usuariosSelect = val;
    },
    openUsersModal(val, old) {
      if (!val && old !== val) this.cleanUserInfo();
    }
  },

  computed: {
    ...mapState([
      "colegios_sel",
      "grupo_usuario_list_query",
      "usuarios_list_colegio"
    ]),
    grupos() {
      return this.$store.state.grupos_list;
    },
    storing() {
      return this.$store.state.grupos_load;
    },
    actualUsuariosSelect() {
      const user_grupo = this.grupo_usuario_list_query;
      return this.usuarios_list_colegio.map(elm => {
        elm.selected = !!user_grupo.find(gusr => gusr.usuario_id === elm.id);
        return elm;
      });
    },
    grupoUsuarioTosave() {
      const finalAdd = this.usuariosSelect.filter(usr => usr.selected);
      const toAdd = finalAdd
        .filter(
          usr =>
            !this.grupo_usuario_list_query.find(
              gusr => gusr.usuario_id === usr.id
            )
        )
        .map(usr => ({ usuario_id: usr.id, grupo_id: this.selectedId }));
      const toRemove = this.grupo_usuario_list_query
        .filter(
          gusr =>
            !finalAdd.find(usr => usr.selected && usr.id === gusr.usuario_id)
        )
        .map(group => group.id);
      return { toAdd, toRemove };
    }
  },

  methods: {
    ...mapActions([
      "listGrupo",
      "listUsuarioColegio",
      "listGrupoUsuarioQuery",
      "storeGrupoUsuario",
      "removeGrupoUsuario"
    ]),
    searcher() {
      if (this.timersearch) clearTimeout(this.timersearch);
      this.timersearch = setTimeout(() => this.compareLists(), 300);
    },
    compareLists() {
      const search = this.search;
      if (search === "") this.usuariosSearchAndSelect = this.usuariosSelect;
      else
        this.usuariosSearchAndSelect = this.usuariosSelect.filter(
          usr =>
            (typeof usr.email === "string" && usr.email.indexOf(search) > -1) ||
            (typeof usr.name === "string" && usr.name.indexOf(search) > -1)
        );
    },
    setElementUsuario(id, destiny, value) {
      const index = this.usuariosSelect.findIndex(usr => usr.id === id);
      const element = this.usuariosSelect[index];
      element[destiny] = value;
      this.$set(this.usuariosSelect, index, element);
    },
    setDetalles(elm) {
      this.setObjetive(elm);
      this.openUsersModal = true;
      this.listUsuarioColegio();
      this.listGrupoUsuarioQuery({
        where: "grupo_id",
        op: "==",
        value: elm.id
      });
    },
    reloadData() {
      return this.listGrupo();
    },
    reloadUserData() {
      return this.listUsuarioColegio();
    },
    reloadGrupoUserData(query) {
      return this.listGrupoUsuarioQuery(query);
    },
    cleanUserInfo() {
      this.usuariosSelect = [];
      this.usuariosSearchAndSelect = [];
      this.search = "";
      this.selectedId = null;
      this.$store.commit("setState", {
        key: "grupo_usuario_list_query",
        value: []
      });
    },
    addData() {
      this.openModal = true;
    },
    setDelete(id) {
      this.confirmModal = id;
    },
    continueDelete(id) {
      this.confirmModal = false;
      return this.$store
        .dispatch("removeGrupo", { id })
        .then(() =>
          this.$toastr("success", "El registro se ha eliminado correctamente.")
        );
    },
    setObjetive(cong) {
      this.selectedId = cong.id;
      this.selectedId = cong.id;
      this.objetivo.name = cong.name;
      this.objetivo.notes = cong.notes;
      this.objetivo.usuarios = cong.usuarios;
    },
    setedition(cong) {
      this.setObjetive(cong);
      this.openModal = true;
    },
    async saveDataUsuarios() {
      if (this.grupoUsuarioTosave.toAdd.length)
        await Promise.all(
          this.grupoUsuarioTosave.toAdd.map(data =>
            this.storeGrupoUsuario({ data })
          )
        );
      if (this.grupoUsuarioTosave.toRemove.length)
        await Promise.all(
          this.grupoUsuarioTosave.toRemove.map(id =>
            this.removeGrupoUsuario({ id })
          )
        );
      this.objetivo.usuarios =
        this.objetivo.usuarios +
        this.grupoUsuarioTosave.toAdd.length -
        this.grupoUsuarioTosave.toRemove.length;
      delete this.objetivo.name;
      delete this.objetivo.notes;
      await this.saveData();
      this.openUsersModal = false;
    },
    async saveData() {
      let action;
      if (!this.selectedId) {
        action = this.$store.dispatch("storeGrupo", {
          data: this.objetivo
        });
      } else {
        action = this.$store.dispatch("updateGrupo", {
          id: this.selectedId,
          data: this.objetivo
        });
      }
      try {
        await action;
        this.objetivo.name = "";
        this.objetivo.notes = "";
        this.objetivo.usuarios = 0;
        this.$toastr(
          "success",
          this.selectedId
            ? "El registro se actualizó correctamente."
            : "El registro se creó correctamente."
        );
      } catch (error) {
        console.error(error);
        this.$toastr(
          "error",
          this.selectedId
            ? "El registro no se pudo actualizar."
            : "El registro no se pudo crear."
        );
      }
      this.selectedId = null;
      this.openModal = false;
    }
  }
};
</script>
